import { Palette } from '@common/theming/Palette';
import React, { useEffect, useState } from 'react';
import { ImageGalleryWeb } from '../components/ImageGalleryWeb';
import { DESKTOP_CONTENT_WIDTH } from '../constants';
import { Asset } from '../elements/Mobile';
import { PortfolioAsset } from '../types';

type AssetMobileProps = {
  asset: PortfolioAsset;
};

type AssetMobileState = 'ASSET' | 'IMAGE_GALLERY';
const AssetMobile: React.FC<AssetMobileProps> = ({ asset }) => {
  const [currentState, setCurrentState] = useState<AssetMobileState>('ASSET');
  useEffect(() => {
    document.body.style.backgroundColor = Palette.WHITE;
  });

  const showImageGallery = () => {
    setCurrentState('IMAGE_GALLERY');
  };
  let content;

  switch (currentState) {
    case 'ASSET':
      content = <Asset asset={asset} showImageGallery={showImageGallery} />;
      break;
    case 'IMAGE_GALLERY':
      content = (
        <div
          style={{
            backgroundColor: Palette.WHITE,
            height: '100vh',
            margin: 'auto',
            maxWidth: DESKTOP_CONTENT_WIDTH,
            width: '100%',
          }}>
          <ImageGalleryWeb
            mode="mobile"
            header={true}
            images={asset ? asset?.images.map((image) => image.file.url) : []}
            showAsset={() => {
              setCurrentState('ASSET');
            }}
            title={asset?.header.title}
          />
        </div>
      );
      break;
  }
  return content;
};

export default AssetMobile;
